<template>
  <label class="checkbox-radio">
    <input
      class="visually-hidden checkbox-radio__input"
      :name="name"
      :type="type"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      @change="event => $emit('update', event.target.checked ? value : false)"
    >
    <span
      class="checkbox-radio__box"
      aria-hidden="true"
    />
    <span
      class="ml-xs"
      v-text="label"
    />
  </label>
</template>

<script>

/**
 * Vue: Checkbox input (checkbox-radio)
 * -----------------------------------------------------------------------------
 * Input utility component that doubles as both checkbox or radio.
 * The checked state uses a new design with a square and inner black box.
 *
 * @param {String} label - Input label.
 * @param {Number|String} [value] - Value of checkbox
 * @param {String} [name] - Name of checkbox
 * @param {String} [type] - "checkbox" or "radio"
 *
 * @emits update - Emitted v-model event.
 *
 */
export default {
  name: 'CheckboxRadio',

  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: {
    update: (payload) => typeof payload === 'string' || typeof payload === 'boolean',
  },
}
</script>

<style lang="scss">
@import './checkbox-radio';
</style>
